import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import {Pie,  Bar, HorizontalBar, Radar} from 'react-chartjs-2';
import Modal from '../components/Modal'
import LegendInfo from '../components/LegendInfo';
import SubChart from './SubChart';
import Error from '../components/Error';
import Legend from '../components/Legend';
import Loader from '../components/Loader';
import * as apiCalls from '../lib/apiCalls';
import * as helpers from '../lib/helpers';
import Footer from '../Footer'
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'
import moment from 'moment';
import 'moment/locale/el';
import './Overview.css';

const NOTAUTH = 403;
const SERERROR = 500;
const errorAnalysisMax  = 10;
const errorPerFieldMax = 20;
const errorPerTypeMax = 15;

class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
         overview: {},
         datasetIndex: 0,
         showInstitutionSelect: true,
         generalData: {
             labels: [],
             legendLabels: [],
             datasets: [{
                 data: [100, 0],
                 backgroundColor: [
                     'rgba(174, 227, 185, 0.7)',
                     'rgba( 231, 159, 159, 0.7)'
                 ]
             }]
         },
         data : {},
         chosenDepId: 'all',
         chosenDepName: 'All Departments',
         chosenDepTotalCount: 0,
         errorSpecificData: {
             labels: [],
             legendLabels: [],
             datasets: [],
         },
         errorByPropertyData: {
             labels: [],
             legendLabels: [],
             datasets: []
         },
         errorByTypeData: {
            labels: [],
            legendLabels: [],
            datasets: []
         },
         transition: 'in-transition',
         pieModalIsOpen: false,
         typeModalIsOpen: false,
         propertyModalIsOpen: false,
         pieModalChosenContent: {},
         typeModalChosenContent: {},
         propModalChosenContent: {},
         horLegendFontSize: 12,
         modalTransition : '',
         redirect: false,
         noErrors: false,
         redirectToLogin: false,
         redirectToError: false,
         redirectDepId: '',
         boxTransition: false,
         loading: 'initial',
         departmentFontSize: 'regular',
         timers: []
      }
      this.myBarChart = React.createRef();
      this.myPieChart = React.createRef();
      this.propertyChart = React.createRef();
      this.errorTypeChart = React.createRef();
      this.typeModalChart = React.createRef();
      this.propModalChart = React.createRef();
      this.changeInstitutionResults = this.changeInstitutionResults.bind(this);
    }

    openPieModal = (i) => {
        this.setState({pieModalIsOpen: true, pieModalChosenContent: {
            labelColor: this.state.generalData.backgroundColor[i],
            errorsPerClass: this.state.generalData.errorsPerClass[i], 
            allData: this.state.overview.severityClasses,
            id: this.state.overview.severityClasses[i].classId,
            // index: i,
        }});
        this.props.handleModal(true);
    }

    updatePieModal = (chosenClass) => {
        let index = this.state.overview.severityClasses.map(cl => cl.classId).indexOf(chosenClass);
        this.setState(
            prevState => ({
                pieModalChosenContent: {
                    ...prevState.pieModalChosenContent,
                },
                modalTransition: 'modal-transition',
            })
        )
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState(prevState => ({
                        pieModalChosenContent: {
                            ...prevState.pieModalChosenContent,
                            id: chosenClass,
                            labelColor: this.state.generalData.backgroundColor[index],
                            errorsPerClass: this.state.generalData.errorsPerClass[index],
                        },
                        modalTransition: '',
                    }))
                }, 300)
            ]]
        }))
    }

    closePieModal = () => {
        this.setState({pieModalIsOpen: false});
        this.props.handleModal(false);
    }

    openTypeModal = (i) => {
        this.setState({typeModalIsOpen: true, typeModalChosenContent: {
            id: this.state.overview.errorTypeClasses[i].errorType,
            index: i,
            labelColor: this.state.errorByTypeData.backgroundColor[i],
            allData: this.state.overview.errorTypeClasses,
            idName: 'errorType',
            polyglotId: 'errorsType',
            chartData: this.state.overview.errorTypeClasses[i].errorsPerType,
            chartRef: this.typeModalChart,   
        },
        modalTransition: 'modal-transition'
    });
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState(prevState => ({
                        modalTransition: '',
                    }))
                }, 400)
            ]]
        }))
        this.props.handleModal(true);
    }

    updateTypeModal = (chosenClass) => {
        let index = this.state.overview.errorTypeClasses.map(cl => cl.errorType).indexOf(chosenClass);
        this.setState(
            prevState => ({
                typeModalChosenContent: {
                    ...prevState.typeModalChosenContent         
                },
                modalTransition: 'modal-transition',
            })
        )
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState(prevState => ({
                        typeModalChosenContent: {
                            ...prevState.typeModalChosenContent,
                            id: chosenClass,
                            labelColor: this.state.errorByTypeData.backgroundColor[index],
                            chartData: this.state.overview.errorTypeClasses[index].errorsPerType           
                        },
                        modalTransition: ''
                    }))
                }, 300)
            ]]
        }))
    }

    closeTypeModal = () => {
        this.setState({typeModalIsOpen: false});
        this.props.handleModal(false);
    }

    openPropertyModal = (i) => {
        this.setState({propertyModalIsOpen: true, propModalChosenContent: {
            id: this.state.overview.propertyClasses[i].propertyId,
            index: i,
            labelColor: this.state.errorByPropertyData.backgroundColor[i],
            allData: this.state.overview.propertyClasses,
            idName: 'propertyId',
            polyglotId: 'errorsProperty',
            chartData: this.state.overview.propertyClasses[i].errorsPerProperty,
            chartRef: this.propModalChart,
        },
        modalTransition: 'modal-transition',
    });
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState(prevState => ({
                        modalTransition: '',
                    }))
                }, 400)
            ]]
        }))
        this.props.handleModal(true);
    }

    updatePropertyModal = (chosenClass) => {
        let index = this.state.overview.propertyClasses.map(cl => cl.propertyId).indexOf(chosenClass);
        this.setState(
            prevState => ({
                propModalChosenContent: {
                    ...prevState.propModalChosenContent
                },
                modalTransition: 'modal-transition',
            })
        )
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState, [
                setTimeout(() => {
                    this.setState(prevState => ({
                        propModalChosenContent: {
                            ...prevState.propModalChosenContent,
                            id: chosenClass,
                            labelColor: this.state.errorByPropertyData.backgroundColor[index],
                            chartData: this.state.overview.propertyClasses[index].errorsPerProperty    
                        },
                        modalTransition: '',
                    }))
                }, 300)
            ]]
        }))
    }

    closePropertyModal = () => {
        this.setState({propertyModalIsOpen: false});
        this.props.handleModal(false);        
    }

    changeGeneralData = (data) => {
        let labels = [];
        let colors = [];
        let errorsPerClass = []
        let percentages = []
        if(data.severityClasses.length === 0) {
            let severityClasses = [
                {
                    classId: 0,
                    count: this.state.overview.totalRecordsCount,
                    percentage: 1,
                    errors: []
                }
            ]
            data.severityClasses = severityClasses;
            this.setState(prevState => ({
                ...prevState,
                severityClasses
            }))
        }
        let newGeneralData = {
            ...this.state.generalData,
            datasets: [{
                ...this.state.generalData.datasets[0],
                data: [
                    ...data.severityClasses.map(cl => {
                        let perc = helpers.truncateFloat(cl.percentage);
                        labels.push(`${this.context.polyglot.t(`grades.${cl.classId}`)} : ${cl.count} `)
                        let color = helpers.generateErrorColor(cl.classId)
                        colors.push(color)
                        errorsPerClass.push(cl.errors)
                        percentages.push(perc)
                        return cl.count;
                    })
                ],
                backgroundColor: colors
            }],
            labels,
            legendLabels: labels,
            percentages,
            backgroundColor: colors,
            errorsPerClass
        }
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState({
                        generalData: newGeneralData
                    })
                }, 700)
            ]]
        }))
    }

    changeErrorSpecificData = (data) => {
        let colorsUsed = [];
        let labels = [];
        let counts = data.errorAnalysis.map(err => err.count);
        let normalizedCounts = helpers.normalizeToRange(counts, 1, errorAnalysisMax);
        let newErrorData = {
            ...this.state.errorSpecificData,
            datasets: [
                ...data.errorAnalysis.map((err, i) => {
                        let color = helpers.generateRandomColor(colorsUsed);
                        colorsUsed.push(color);
                        let perc = helpers.truncateFloat(err.percentage);
                        let label = `${this.context.polyglot.t(`errors.${err.errorCode}`)} [${err.errorCode}] : ${err.count} `;
                        labels.push(label);
                        return {
                            label,
                            data: [normalizedCounts[i]],
                            percentage: perc,
                            backgroundColor: color,
                            originalData: [err.count]
                        }
                })
            ],
            legendLabels: labels,
        }
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState({
                        errorSpecificData: newErrorData,
        
                    })
                }, 700)
            ]]
        }))
    }

    changeErrorByPropertyData = (data) => {
        let colorsUsed = [];
        let labels = [];
        let legendLabels = [];
        let propertyClasses = data.propertyClasses.sort((cl1, cl2) => cl1.propertyId > cl2.propertyId)
        data = {...data, propertyClasses}

        let counts = data.propertyClasses.filter(cl => cl.belongsToView === true).map(err => err.count);
        let normalizedCounts = helpers.normalizeToRange(counts, 1, errorPerFieldMax);
        let percentages = []
        data = {
            ...data,
            propertyClasses: data.propertyClasses.filter(cl => cl.belongsToView === true)
        } //TODO: change this if you want idika stats
        let newErrorData = {
            ...this.state.errorByPropertyData,
            datasets: [{
                ...this.state.errorByPropertyData.datasets[0],
                data: [...data.propertyClasses.map((cl, i) => {
                    let color = helpers.generateRandomColor(colorsUsed);
                    colorsUsed.push(color);
                    let perc = helpers.truncateFloat(cl.percentage);
                    let label = `${cl.propertyId}`;
                    let legendLabel = `${this.context.polyglot.t(`errorsProperty.${cl.propertyId}`)} (${cl.propertyId}) : ${cl.count}`;
                    labels.push(label);
                    legendLabels.push(legendLabel);
                    percentages.push(perc)
                    return normalizedCounts[i];
                })],
                backgroundColor: colorsUsed,
            }],
            labels,
            legendLabels,
            percentages,
            backgroundColor: colorsUsed,
            originalData: counts
        }
        this.setState(prevState => ({
            ...prevState,
            overview: data,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState({
                        errorByPropertyData: newErrorData,
        
                    })
                }, 700)
            ]]
        }))
    }

    changeErrorByTypeData = (data) => {
        let colorsUsed = [];
        let legendLabels = [];
        let labels = [];
        let colorPair = {};
        let counts = data.errorTypeClasses.map(err => err.count);
        let normalizedCounts = helpers.normalizeToRange(counts, 1, errorPerTypeMax);
        let percentages = []
        let newErrorData = {
            ...this.state.errorByTypeData,
            datasets: [{
                ...this.state.errorByTypeData.datasets[0],
                data: [
                    ...data.errorTypeClasses.map((cl, i)=> {
                            let color = helpers.generateRandomColor(colorsUsed, 0.6);
                            colorPair = helpers.generateRandomColorPair(colorsUsed, 0.2);
                            colorsUsed.push(color);
                            let perc = helpers.truncateFloat(cl.percentage);
                            let label = `${this.context.polyglot.t(`errorsType.${cl.errorType}`)}`;
                            let legendLabel = `${this.context.polyglot.t(`errorsType.${cl.errorType}`)} : ${cl.count} `
                            labels.push(label);
                            percentages.push(perc)
                            legendLabels.push(legendLabel)
                            return normalizedCounts[i]
                    })
                ]
                ,
                borderWidth: 2,
                pointRadius: 3,
                backgroundColor: colorPair.lightColor,
                borderColor: colorPair.boldColor,
                pointBackgroundColor: colorsUsed,
                spanGaps: true
            }
            ],
            labels,
            legendLabels,
            percentages,
            backgroundColor: colorsUsed,
            originalData: counts
        }
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState({
                        errorByTypeData: newErrorData
                    })
                }, 700)
            ]]
        }))
    }

    handleWrongToken = () => {
        this.setState(prevState => ({
            ...prevState,
            redirectToLogin: true,
            loading: 'false'
        }))
        this.props.handleLogout();
    }

    handleServerError = () => {
        this.setState(prevState => ({
            ...prevState,
            redirectToError: true,
            loading: 'false'
        }))
        // this.props.handleError(true);
    }

    loadInstitutionOverview = async (institutionId, dep, token) => {
        const res = await apiCalls.getInstitutionOverview(institutionId, dep, token, this.props.runType);
        return res;
    };

    async updateComponent() {
        this.setState(prevState => ({ 
            ...prevState,
            loading: 'true' 
        }));
        let depName;
        const depId = this.props.id;
        let data;
        if (depId !== 'all') {
            data = await this.loadInstitutionOverview(this.props.institutionId, depId, this.props.token)
            if (data === NOTAUTH) {
                return this.handleWrongToken();
            }
            if(data === SERERROR || 'error' in data) {
                return this.handleServerError();
            }
            depName = this.props.institution.departments.filter(dep => dep.id === depId)[0].nameEl;
        } else {
            data = await this.loadInstitutionOverview(this.props.institutionId, '', this.props.token);
            if (data === NOTAUTH) {
                return this.handleWrongToken();
            }
            if(data === SERERROR || 'error' in data) {
                return this.handleServerError();
            }
            depName = this.context.polyglot.t('allDepartments');
        }
        const localDate = moment(data.dateOfRun);
        const locale = this.context.polyglot.currentLocale
        localDate.locale(locale);
        data.dateOfRun = localDate.format('llll');
        data = {
            ...data,
            propertyClasses: data.propertyClasses.filter(cl => cl.belongsToView === true && cl.propertyId && this.context.polyglot.has(`errorsProperty.${cl.propertyId}`)),
            errorTypeClasses: data.errorTypeClasses.filter(cl => cl.errorType && this.context.polyglot.has(`errorsType.${cl.errorType}`)),
            errorAnalysis: data.errorAnalysis.filter(cl => cl.errorCode && this.context.polyglot.has(`errors.${cl.errorCode}`))
        }
        let noErrors =  (data.errorAnalysis.length === 0) ? true : false;
        this.setState(prevState => ({ 
            ...prevState,
            loading: 'true' 
        }));
        this.setState({
            overview: data,
            chosenDepId: depId,
            chosenDepName: depName,
            boxTransition: false,
            noErrors,
            loading: false,
            departmentFontSize: depName.length > 50 ? 'small' : 'regular'
        });
        this.changeGeneralData(data);
        this.changeErrorSpecificData(data);
        this.changeErrorByPropertyData(data);
        this.changeErrorByTypeData(data);
        this.setState(prevState => ({
            ...prevState,
            redirectToLogin: false,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState(
                        {transition: '', redirect: false}
                    )
                }, 600)
            ]]
        }))
    }

    componentDidUpdate(prevProps) {
        // let content = document.getElementById('content');
        // content.scrollTop = 0;
        if(prevProps.institution !== this.props.institution || prevProps.id !== this.props.id) {
            this.updateComponent();
        }
    }

    componentDidMount() {
        document.title = this.context.polyglot.t('overviewPageTitle');
        let content = document.getElementById('content');
        content.scrollTop = 0;
        this.updateComponent();
    }

    componentWillMount() {
        //this.updateComponent();
    }

    componentWillUnmount() {
        this.state.timers.map(timer => clearTimeout(timer));
    }

    changeInstitutionResults(e) {
        let depId = e.target.value;
        this.setState(
            {
                transition: 'in-transition',
                loading: true
            }
        )
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState({
                        redirectDepId: depId,
                        redirect: true
                    })
                }, 500)
            ]]
        }))
    }

    openTip = (chartRef, index, pointIndex) => {
        let chart = chartRef.current.chartInstance;
        if(!chart) {
            return;
        }
        let activeElements = chart.tooltip._active;
        let requestedElem = chart.getDatasetMeta(index).data[pointIndex];
        if(!activeElements) {
            chart.tooltip._active = [];
            activeElements = chart.tooltip._active;
        }
        if(activeElements) {
            for(var i = 0; i < activeElements.length; i++) {
                if(requestedElem._index === activeElements[i]._index)  
                   return;
            }
            activeElements.push(requestedElem);
            chart.tooltip._active = activeElements;
            chart.tooltip.update(true);
            setTimeout(() => {
                if(!chart.ctx) {
                    return;
                }
                chart.draw();
            }, 450)
        }
    } 

    closeTip = (chartRef, index, pointIndex) => {
        let chart = chartRef.current.chartInstance;
        if(!chart) {
            return;
        }
        let activeElements = chart.tooltip._active;
        let requestedElem = chart.getDatasetMeta(index).data[pointIndex];
        if(!activeElements) {
            chart.tooltip._active = [];
            activeElements = chart.tooltip._active;
        }
        if(activeElements) {
            for(var i = 0; i < activeElements.length; i++) {
                if(requestedElem._index === activeElements[i]._index)  {
                   activeElements.splice(i, 1);
                   break;
                }
            }
            activeElements.push(requestedElem);
            chart.tooltip._active = [];
            chart.tooltip.update(true);
            setTimeout(() => {
                if(!chart.ctx) {
                    return;
                }
                chart.draw();
            }, 450)
        }
    }

    render() {
        if (this.state.loading === 'true' || this.state.loading === 'initial') {
            return <Loader />
        }

        if(this.state.redirectToLogin === true) {
            return <Redirect push to={`/login?next=${this.props.location}`}/>
        }

        if(this.state.redirectToError === true) {
            return <Error />
        }

        if(this.state.redirect === true && this.state.redirectDepId !== this.props.id) {
            return <Redirect push from={this.props.id} to={this.state.redirectDepId}/>
        }

        return (
          <LanguageConsumer>
            {({polyglot}) => (
            <div id='overview' className={`Overview ${this.state.showInstitutionSelect} ${this.state.noErrors ? 'noErrors' : ''} ${this.state.boxTransition ? 'box-transition' : ''}`} onScroll={this.onScroll}>
                <div className = "Overview-header">
                    <div className='Overview-title'><h1>{this.props.institutionId.toUpperCase()}</h1></div>
                    <span className={`Overview-subtitle ${this.state.transition} ${this.state.departmentFontSize}`}><h4>{this.state.chosenDepName}</h4></span>
                    <div className='Overview-date'><i className="fa fa-calendar-check"></i> {polyglot.t('lastRun')}: <span id="Overview-datestr" className={this.state.transition}>{`  ${this.state.overview.dateOfRun}`}</span> </div>
                    <div className='Overview-totalCount'><i className="fa fa-users"></i> {polyglot.t('numberOfRecordsChecked')}: <span className={`Overview-countNumber ${this.state.transition}`}>{this.state.overview.totalRecordsCount}</span></div>
                    <div className='Overview-query'><i className="fas fa-filter"></i> {polyglot.t('databaseFilter')}: <span className={`Overview-filter ${this.state.transition}`}><i>{this.state.overview.whereClause}</i></span></div>
                    <div className='Overview-info'> <i className="fas fa-info"></i> {polyglot.t('overviewInfo')}</div>
                    <span id="select-ovResults" className="input-group">
                        <span className="input-name" id="Overview-results-name">{polyglot.t('resultsFor')}:</span>
                        <span className="select-group">
                            <div className="select">
                                <select value={this.state.chosenDepId} onChange={this.changeInstitutionResults}>
                                    <option value='all'> {polyglot.t('allDepartments')} </option>
                                    {
                                    this.props.institution.departments.map(dep => <option key={dep.id} value={dep.id}>{helpers.removeSpecialChars(dep.nameEl)}</option>)
                                    }
                                </select>
                            </div>
                        </span>
                    </span>
                </div>
                <div className={`box1`}>
                    <div className={`header-box`}>
                        <h4>{polyglot.t('errorsPerSeverity')}</h4>
                        <hr/>
                    </div>
                    <Modal
                            isOpen={this.state.pieModalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closePieModal}
                            contentLabel="Example Modal"
                        >
                            <LegendInfo modalTransition={this.state.modalTransition} content={this.state.pieModalChosenContent} handleChange={this.updatePieModal} closeModal={this.closePieModal}/> 
                    </Modal>
                    <div id="chart-container1" className={`${this.state.transition}`}>
                        <Legend id="pie-legend" data={this.state.generalData} openTip={this.openTip} closeTip={this.closeTip} typeOfChart='Pie' clickHandler={this.openPieModal} clickable={true} chartRef={this.myPieChart}/>
                        <div id="pie-chart-container">
                            <Pie 
                                ref = {this.myPieChart}
                                data={this.state.generalData} 
                                width={10}
                                height={10}
                                options={{
                                    maintainAspectRatio: false, 
                                    legend: {
                                        position: 'left',
                                        display: false
                                    },
                                    events: ['click', 'mousemove', 'mouseout'],
                                    onClick:() => {
                                        let chart = this.myPieChart.current.chartInstance;
                                        if(chart.active[0]){
                                            let activeElement = chart.active[0]._index;
                                            this.openPieModal(activeElement)
                                        }
                                    },
                                    onHover: (e) => {
                                        e.target.style.cursor = 'pointer'
                                    },
                                    tooltips: {
                                        mode: 'nearest',
                                        callbacks: {
                                            label: (tooltipItem, data) => {
                                                let label = `${this.state.generalData.legendLabels[tooltipItem.index]} (${this.state.generalData.percentages[tooltipItem.index]}%)`;
                                                return label;
                                             }
                                        }
                                    },

                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="box2">
                        <div className='header-box'>
                            <h4>{polyglot.t('errorsPerType')}</h4>
                            <hr/>
                        </div>
                        <Modal
                            isOpen={this.state.typeModalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeTypeModal}
                            className=''
                            contentLabel="Example Modal"
                        >
                            <SubChart modalTransition={this.state.modalTransition} content={this.state.typeModalChosenContent} handleChange={this.updateTypeModal} openTip={this.openTip} closeTip={this.closeTip} closeModal={this.closeTypeModal} chart={this.state.typeModalChart}/>
                        </Modal>
                        <div id="chart-container4" className={`${this.state.transition}`}>
                        <Legend id={"radar-legend"} data={this.state.errorByTypeData} openTip={this.openTip} closeTip={this.closeTip} clickHandler={this.openTypeModal} clickable={true} typeOfChart='Radar' chartRef={this.errorTypeChart}/>
                        <div id="radar-chart-container">
                            <Radar
                                ref={this.errorTypeChart}
                                className={`${this.state.transition}`}
                                data={this.state.errorByTypeData} width={10}
                                height={30}
                                options={{
                                    maintainAspectRatio: false,
                                    elements: {
                                        point: {
                                            drawNull: false,
                                            skipNull: true
                                        },
                                        line: {
                                            drawNull: true,
                                            skipNull: false
                                        },
                                        arc: {
                                            drawNull: true,
                                            skipNull: false
                                        }
                                    },
                                    legend: {
                                        position: 'left',
                                        display: false,
                                        fullWidth: true
                                    },
                                    events: ['click', 'mousemove', 'mouseout'],
                                    onClick:() => {
                                        let chart = this.errorTypeChart.current.chartInstance;
                                        if(chart.active[0]){
                                            let activeElement = chart.active[0]._index;
                                            this.openTypeModal(activeElement)
                                        }
                                    },
                                    onHover: (e) => {
                                        e.target.style.cursor = 'pointer'
                                    },
                                    scales: {
                                        ticks: {
                                            beginAtZero:true,
                                            min: 0,
                                            max: errorPerTypeMax,
                                        }
                                    },
                                    tooltips: {
                                        mode: 'nearest',
                                        callbacks: {
                                            title: () => {
                                                return '';
                                            },
                                            label: (tooltipItem, data) => {
                                                let label = `${this.state.errorByTypeData.legendLabels[tooltipItem.index]} (${this.state.errorByTypeData.percentages[tooltipItem.index]}%)`;
                                                return label;
                                             }
                                        }
                                    },
                                }}
                            />
                        </div>
                        </div>
                </div>
                <div className="box-wrapper">
                    <div className="box3">
                        <div className='header-box'>
                            <h4>{polyglot.t('errorsPerProperty')}</h4>
                            <hr/>
                        </div>
                        <Modal
                            isOpen={this.state.propertyModalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closePropertyModal}
                            className=''
                            contentLabel="Example Modal"
                        >
                            <SubChart modalTransition={this.state.modalTransition} content={this.state.propModalChosenContent} handleChange={this.updatePropertyModal} closeModal={this.closePropertyModal} openTip={this.openTip} closeTip={this.closeTip} chart={this.state.propModalChart}/>
                        </Modal>
                        <div id="chart-container3" className={`${this.state.transition}`}>
                        <Legend id={"categbar-legend"} data={this.state.errorByPropertyData} openTip={this.openTip} closeTip={this.closeTip} clickHandler={this.openPropertyModal} clickable={true} typeOfChart='CategBar' chartRef={this.propertyChart}/>
                        <div id="bar-properties-container">
                            <HorizontalBar
                                ref={this.propertyChart}
                                className={`${this.state.transition}`}
                                data={this.state.errorByPropertyData} width={10}
                                height={30}
                                options={{
                                    maintainAspectRatio: false,
                                    legend: {
                                        position: 'left',
                                        display: false,
                                        fullWidth: true
                                    },
                                    layout: {
                                        padding: {
                                            left: 35,
                                            right: 20,
                                            top: 0,
                                            bottom: 0
                                        }
                                    },
                                    events: ['click', 'mousemove', 'mouseout'],
                                    onClick:() => {
                                        let chart = this.propertyChart.current.chartInstance;
                                        if(chart.active[0]){
                                            let activeElement = chart.active[0]._index;
                                            this.openPropertyModal(activeElement)
                                        }
                                    },
                                    onHover: (e) => {
                                        e.target.style.cursor = 'pointer'
                                    },  
                                    tooltips: {
                                        mode: 'nearest',
                                        callbacks: {
                                            title: () => {
                                                return '';
                                            },
                                            label: (tooltipItem, data) => {
                                                let label = `${this.state.errorByPropertyData.legendLabels[tooltipItem.index]} (${this.state.errorByPropertyData.percentages[tooltipItem.index]}%)`;
                                                return label;
                                             }
                                        }
                                    },
                                    scales: {
                                        yAxes: [{
                                            maxBarThickness: 35,
                                            ticks: {
                                                fontSize: this.state.horLegendFontSize,
                                                beginAtZero: true,
                                                max: errorPerFieldMax,
                                            }
                                        }],
                                        xAxes: [{
                                            ticks: {
                                                fontSize: this.state.horLegendFontSize,
                                                beginAtZero: true,
                                            }
                                        }]
                                    },
                                }}
                            />
                        </div>
                    </div>
                    </div>    
                    <div className="box4">
                        <div className='header-box'>
                            <h4>{polyglot.t('errorAnalysis')}</h4>
                            <hr/>
                        </div>
                        <div id="chart-container2" className={`${this.state.transition}`}>
                            <Legend id={"bar-legend"} data={this.state.errorSpecificData} openTip={this.openTip} closeTip={this.closeTip} typeOfChart='Bar' chartRef={this.myBarChart}/>
                            <div id="bar-chart-container">
                                <Bar
                                    ref={this.myBarChart}
                                    className={`${this.state.transition}`}
                                    data={this.state.errorSpecificData} width={10}
                                    height={30}
                                    options={{
                                        maintainAspectRatio: false, 
                                        legend: {
                                            position: 'left',
                                            display: false,
                                            fullWidth: true
                                        },
                                        scales: {
                                            yAxes: [{
                                                ticks: {
                                                    beginAtZero: true,
                                                    max: errorAnalysisMax
                                                }
                                            }]
                                        },
                                        tooltips: {
                                            mode: 'nearest',
                                            callbacks: {
                                                label: (tooltipItem, data) => {
                                                    let newLabel = '';
                                                    let item = this.state.errorSpecificData.datasets[tooltipItem.datasetIndex];
                                                    let oldLabel = `${item.label} (${item.percentage})%`;
                                                    oldLabel = oldLabel.split(" ").filter(word => word.length > 0).slice(0, 5)
                                                    oldLabel.map((word, i) =>
                                                        (newLabel += `${word} `)
                                                    )
                                                    return newLabel;
                                                },
                                                afterLabel: (tooltipItem, data) => {
                                                    let multiLineLabel = [];
                                                    let tempStr = '';
                                                    let item = this.state.errorSpecificData.datasets[tooltipItem.datasetIndex];
                                                    let newLabel = `${item.label} (${item.percentage}%)`
                                                    let restLabel = newLabel.split(" ").filter(word => word.length > 0).slice(5);
                                                    restLabel.map((word, i) => {
                                                        tempStr += `${word} `;
                                                        if((i+1)%5 === 0 || restLabel.length-i === 1) {
                                                            multiLineLabel.push(tempStr)
                                                            tempStr = '';
                                                        }
                                                        return 0;
                                                    })
                                                    return multiLineLabel;
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>)}
         </LanguageConsumer>
        )
    }
}
Overview.contextType = LanguageContext

export default Overview;



// WEBPACK FOOTER //
// ./src/overview/Overview.js